import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import { Box } from '@mui/material'
import Header from './Header'

const Layout = ({ children }) => {
  return (
    <section>
      <Header />
      <Box component="main">
        <Outlet />
      </Box>
      <Footer />
    </section>
  )
}

export default Layout
